// import 'frontent/pages/messenger.css'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux' 
import { cleanupConversations, resetCreateConversation } from '../../features/messenger/conversationSlice' 
import NewConversationBtn from './startConversation/NewConversationBtn' 
import { getMyProfile } from '../../features/profile/profileSlice'
import styled from 'styled-components' 
import { useState } from 'react'
import ConversationsFeed from './conversation/ConversationsFeed'
import ChurchFeedbacksFeed from 'components/churchFeedback/ChurchFeedbacksFeed'
import { pBtn } from 'components/main.styled'
import { VscFeedback } from "react-icons/vsc";
import { PiChatsLight } from "react-icons/pi";
import ConversationsContainer from 'components/marketplace/conversations/ConversationsContainer'
import { useTranslation } from 'react-i18next'

function Conversations() {
    const { t } = useTranslation('messaging')

    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth) 
    const { myProfile  } = useSelector((state) => state.profile) 
    const [view, setView] = useState('conversations')

    useEffect(() => { 
        if(!myProfile) {
            dispatch(getMyProfile())
        }
    }, [dispatch,  myProfile] )


    return (
        <ConversationsContainerDiv>
            <ConversationsWrap>
                <ConvoTop>
                    <MyConvos>
                        {
                            !user.isOrganization &&
                            (
                                t('conversation.conversations')
                            )
                        } 
                    </MyConvos>
                    <NewConversationBtn  />
                </ConvoTop>

                {
                    user.isOrganization ? 
                    (
                        <ViewContainer>
                            <ViewTabs>
                                <ViewTab 
                                    onClick={() => setView('conversations')} 
                                    active={view === 'conversations'}
                                    >
                                        <PiChatsLight size={20}/>
                                        <span>{t('conversation.conversations')}</span>
                                </ViewTab>
                                <ViewTab 
                                    onClick={() => setView('feedbacks')} 
                                    active={view === 'feedbacks'}
                                    >
                                        <VscFeedback size={20} />
                                        <span>Feedback</span>
                                </ViewTab>
                            </ViewTabs>

                            {
                                view === 'conversations' ?
                                (
                                    <ConversationsFeed />
                                )
                                :
                                (
                                    <ChurchFeedbacksFeed />
                                )
                            }
                        </ViewContainer>
                    )
                    :
                    (
                        <ConversationsFeed />
                    )
                } 
            </ConversationsWrap> 
        </ConversationsContainerDiv>
    )
}

export default Conversations

const ConversationsContainerDiv = styled.div`
    display: flex;
    width: 350px;
    height: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 
`

const ViewTabs = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 15px;
    margin-bottom: 10px;
`

const ViewTab = styled(pBtn)`
    pointer-events: ${props => props.active ? 'none' : 'auto'}; 
    color: ${props => props.active ? 'white' : 'var(--lightThemeFontColor)'};
    background-color: ${props => props.active ? 'var(--themeColor)' : 'transparent'}; 
    &:hover{
        background-color: #d5d5d5;
    }
`
const ViewContainer = styled.div`
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 
`

const ConversationsWrap = styled.div`
    width: 100%; 
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border: none;
    border-radius: 25px;
    height: 100%;
    background-color: white;    
    padding: 10px;
    box-shadow: 0px 0px 5px #ccc;

    @media (max-width: 768px) {
        min-width: unset;
        max-width: unset;
        width: 100%;
        height: calc(100vh - 77px);  
        border-right: unset;
        border-radius: 25px;
        overflow-y: scroll;
    }
`
const ConvoTop = styled.div` 
    width: 100%;
    display: flex;
    flex-direction: row;
    height: fit-content;
    align-items: center; 
    justify-content: space-between;
    padding: 10px;
    @media (max-width: 768px) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        padding-right: 10px;
    }
`

const MyConvos = styled.div` 
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start; 
    height: 100%;
    font-size: 11px;
    color: rgb(100,100,100);
    @media (max-width: 768px) {
        padding: 0px; 
        padding-left: 5px;
        margin-right: 10px;
        margin-top: 0px;
    }
`
